import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "gaokao-bank-page" }
const _hoisted_2 = { class: "filter-panel" }
const _hoisted_3 = {
  key: 1,
  class: "paper-grid"
}
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "paper-card__meta" }
const _hoisted_6 = { class: "paper-card__actions" }
const _hoisted_7 = ["href"]
const _hoisted_8 = {
  key: 0,
  class: "gaokao-pagination"
}

import { computed, onMounted, reactive, ref } from "vue";
import { useRouter } from "vue-router";
import { message } from "ant-design-vue";
import { getGaokaoPaperListApi } from "@/servers/api/papers";

type PaperItem = {
  id: number;
  name: string;
  subject: string;
  year: string;
};


export default /*@__PURE__*/_defineComponent({
  __name: 'GaokaoQuestionBank',
  setup(__props) {

const router = useRouter();

const SUBJECTS = ["语文", "数学", "英语", "物理", "化学", "生物", "政治", "历史", "地理"];
const subjectOptions = SUBJECTS.map((value) => ({ label: value, value }));

const currentYear = new Date().getFullYear();
const yearOptions = Array.from({ length: 25 }, (_, index) => {
  const year = String(currentYear - index);
  return { label: `${year} 年`, value: year };
});

const filterOption = (input: string, option: any) =>
  String(option?.label ?? "").toLowerCase().includes(input.toLowerCase());

const loading = ref(false);
const papers = ref<PaperItem[]>([]);
const total = ref(0);
const filters = reactive<{ subject?: string; year?: string; keyword?: string }>({
  subject: undefined,
  year: undefined,
  keyword: undefined,
});
const pagination = reactive({ page: 1, size: 24 });

// 名称关键词在已加载结果内做前端过滤（后端仅支持科目/年份）
const filteredPapers = computed(() => {
  const keyword = (filters.keyword || "").trim().toLowerCase();
  if (!keyword) return papers.value;
  return papers.value.filter((paper) => paper.name.toLowerCase().includes(keyword));
});

const isSuccess = (response?: { code?: number }) =>
  response?.code === undefined || response?.code === 0 || response?.code === 200;

const loadPapers = async () => {
  loading.value = true;
  try {
    const response = await getGaokaoPaperListApi({
      subject: filters.subject || undefined,
      year: filters.year || undefined,
      page: pagination.page,
      size: pagination.size,
    });
    if (!isSuccess(response)) {
      message.error(response?.msg || "获取高考试卷失败");
      return;
    }
    papers.value = (response?.data as PaperItem[]) || [];
    total.value = Number(response?.total ?? papers.value.length);
  } catch (error: any) {
    message.error(error?.message || "获取高考试卷失败");
  } finally {
    loading.value = false;
  }
};

const handleSearch = () => {
  pagination.page = 1;
  loadPapers();
};

const handleReset = () => {
  filters.subject = undefined;
  filters.year = undefined;
  filters.keyword = undefined;
  handleSearch();
};

const handlePageChange = (page: number) => {
  pagination.page = page;
  loadPapers();
};

// 打开独立详情页（不用抽屉）
const openPaper = (paper: PaperItem) => {
  router.push({ name: "gaokaoPaperDetail", params: { paperId: String(paper.id) } });
};

onMounted(() => {
  loadPapers();
});

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_pagination = _resolveComponent("a-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("header", { class: "page-header" }, [
      _createElementVNode("div", null, [
        _createElementVNode("h2", null, "高考试题"),
        _createElementVNode("p", null, "按科目、年份筛选历年高考真题，进入试卷查看逐题内容（公式已渲染）。")
      ])
    ], -1)),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_a_select, {
        value: filters.subject,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((filters.subject) = $event)),
        placeholder: "科目",
        options: _unref(subjectOptions),
        "allow-clear": "",
        "show-search": "",
        "filter-option": filterOption,
        style: {"width":"140px"},
        onChange: handleSearch
      }, null, 8, ["value", "options"]),
      _createVNode(_component_a_select, {
        value: filters.year,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((filters.year) = $event)),
        placeholder: "年份",
        options: _unref(yearOptions),
        "allow-clear": "",
        "show-search": "",
        style: {"width":"140px"},
        onChange: handleSearch
      }, null, 8, ["value", "options"]),
      _createVNode(_component_a_input, {
        value: filters.keyword,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((filters.keyword) = $event)),
        placeholder: "试卷名称关键词",
        "allow-clear": "",
        style: {"width":"220px"},
        onPressEnter: handleSearch
      }, null, 8, ["value"]),
      _createVNode(_component_a_button, {
        type: "primary",
        loading: loading.value,
        onClick: handleSearch
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode("查询", -1)
        ]))]),
        _: 1
      }, 8, ["loading"]),
      _createVNode(_component_a_button, { onClick: handleReset }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode("重置", -1)
        ]))]),
        _: 1
      })
    ]),
    _createVNode(_component_a_spin, { spinning: loading.value }, {
      default: _withCtx(() => [
        (!loading.value && filteredPapers.value.length === 0)
          ? (_openBlock(), _createBlock(_component_a_empty, {
              key: 0,
              description: "暂无高考试卷"
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredPapers.value, (paper) => {
                return (_openBlock(), _createBlock(_component_a_card, {
                  key: paper.id,
                  class: "paper-card",
                  size: "small",
                  hoverable: ""
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "paper-card__title",
                      title: paper.name
                    }, _toDisplayString(paper.name), 9, _hoisted_4),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_a_tag, { color: "blue" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(paper.year) + " 年", 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_tag, { color: "green" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(paper.subject), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_a_button, {
                        type: "link",
                        size: "small",
                        onClick: ($event: any) => (openPaper(paper))
                      }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                          _createTextVNode("查看题目", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createElementVNode("a", {
                        class: "paper-card__download",
                        href: `/api/gaokao/papers/files/${paper.id}/`,
                        target: "_blank",
                        rel: "noopener"
                      }, "下载试卷", 8, _hoisted_7)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
      ]),
      _: 1
    }, 8, ["spinning"]),
    (total.value > pagination.size)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_a_pagination, {
            current: pagination.page,
            "page-size": pagination.size,
            total: total.value,
            "show-total": (t) => `共 ${t} 份`,
            onChange: handlePageChange
          }, null, 8, ["current", "page-size", "total", "show-total"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})